import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormulaireCoordonneesMouvementCourrielModel } from './formulaire-coordonnees-mouvement-courriel.model';
import { CustomValidators } from '../../validators/custom-validators.validators';

export class FormulaireCoordonneesMouvementCourrielBuilder {
  static buildCourriel(): FormGroup<FormulaireCoordonneesMouvementCourrielModel> {
    return new FormGroup<FormulaireCoordonneesMouvementCourrielModel>({
      courriel: new FormControl<string>('', {
        validators: [Validators.required, CustomValidators.courrielValide],
      }),
      courrielExistant: new FormControl<boolean>(false, { nonNullable: true }),
    });
  }
}
